import React from 'react';
import PropTypes from 'prop-types';
import { Map } from 'immutable';
import RsBreadcrumbTooltip from '@Pages/RetroSynthesis/RsBreadcrumbs/RsBreadcrumbTooltip';
import BreadcrumbTooltipContent from '@Containers/Breadcrumbs/BreadcrumbTooltip/BreadcrumbTooltipContent';

function BreadcrumbTooltip({ id, header, breadcrumb, isAlertVisible, createAlert }) {
  return (
    <RsBreadcrumbTooltip id={id}>
      <BreadcrumbTooltipContent header={header} breadcrumb={breadcrumb} isAlertVisible={isAlertVisible} createAlert={createAlert} />
    </RsBreadcrumbTooltip>
  );
}

BreadcrumbTooltip.propTypes = {
  id: PropTypes.string,
  breadcrumb: PropTypes.instanceOf(Map).isRequired,
  header: PropTypes.oneOfType([PropTypes.object, PropTypes.string]).isRequired,
  isAlertVisible: PropTypes.bool,
  createAlert: PropTypes.func,
};

export default BreadcrumbTooltip;
